import { Component, OnInit } from '@angular/core';
// import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../service/api_service';
// import { FormGroup, FormControl, Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';
// import { HttpClient } from '@angular/common/http';
// import { Injectable } from '@angular/core';
import { Router } from "@angular/router"
import { ColumnGroup } from 'ag-grid-community';
import { Subscription } from 'rxjs';  
@Component({
    selector: 'app-userreport',
    template: require('./userreport.component.html'),
    
    viewProviders: [ApiService]
})
// @Injectable({
//   providedIn: 'root',
// })
export class UserReportComponent implements OnInit {
    userreport: any = [];
    busy: Subscription;
    private columnDefs;
    private rowHeight;
    api: any;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;

    static parameters = [ApiService, Router]
    constructor(private apiService: ApiService, private router: Router) {
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Name', field: "Name", suppressSizeToFit: true },
            { headerName: 'LoginTime', field: "LoginTime" },
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };

    }


    ngOnInit() {
        this.getuserreport();
        // this.gridHeight();

    }


    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.showNoRowsOverlay();
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'employeemaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    getuserreport() {
       this.busy = this.apiService.getuserreport().subscribe((res: any) => {
            this.userreport = res;
            console.log("uuserrrrrrrrrrrr",this.userreport)
        })
    }
}
